import {queryClient} from 'services'
import {
  useSnapshotContext,
  SETTINGS_ENDPOINT_CONFIG_SNAPSHOT,
} from 'context/SnapshotContext'
import {
  defaultEndpointSettingsQueryResponse,
  getEndpointSettingsQueryCache,
  ENDPOINTS_SETTINGS_QUERY_KEY,
} from 'features/Settings/Endpoints/useEndpointSettingsQuery'

export const useEndpointConfigSnapshot = () => {
  const {snapshot, setSnapshot} = useSnapshotContext()

  const endpointConfigSnapshot = snapshot?.[
    SETTINGS_ENDPOINT_CONFIG_SNAPSHOT
  ] as typeof defaultEndpointSettingsQueryResponse

  const handleUpdateSnapshot = (updatedSnapshot: typeof snapshot) => {
    setSnapshot({
      ...snapshot,
      [SETTINGS_ENDPOINT_CONFIG_SNAPSHOT]: updatedSnapshot,
    })
  }

  const handleResetToSnapshot = () => {
    const endpointsSettingConfig = getEndpointSettingsQueryCache()
    if (!endpointConfigSnapshot) {
      return
    }
    const payload = {
      ...endpointsSettingConfig,
      data: endpointConfigSnapshot,
    }
    queryClient.setQueryData([ENDPOINTS_SETTINGS_QUERY_KEY], payload)
  }

  return {
    endpointConfigSnapshot,
    setEndpointConfigSnapshot: handleUpdateSnapshot,
    resetToEndpointConfigSnapshot: handleResetToSnapshot,
  }
}
